<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";
import { vodafoneLabAuthorizationMixin, vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js";
import lockIcon from "!!raw-loader!../../images/lock.svg";
import collectionIcon from "!!raw-loader!../../images/collection-icon.svg";
import collectionIconLight from "!!raw-loader!../../images/collection-icon-light.svg";
import { get } from 'lodash';
import shave from "shave";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabAuthorizationMixin, vodafoneLabBasicMixin],
  data() {
    return {
      bgVideoActive: false,
    };
  },
  props: {
    forceMobileThumbnail: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    Vue.nextTick(() => {
      if (["h1", "h2", "display-1"].includes(this.content.title_class)) {
        shave($(this.$el).find(".dotdotdot-title"), 227);
      } else {
        shave($(this.$el).find(".dotdotdot-title"), 125);
      }

      shave($(this.$el).find(".dotdotdot-subtitle"), 80);
    });
  },
  methods: {
    getContentURL: Fandom.getContentURL,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getTileThumbnailUrl: Fandom.getTileThumbnailUrl
  },
  computed: {
    childrenCount() {
      return this.content.children_count;
    },
    linkLabelClasses() {
      const colors = this.content.theme == "dark" ? "text-white" : "text-dark";
      return this.authorized ? colors : "disabled";
    },
    lockIconClasses() {
      const colors = this.content.theme === "dark" ? "bg-white text-primary" : "bg-primary text-white";
      return [
        colors,
        this.backgroundImage ? "full-right" : ""
      ];
    },
    collectionIconClasses() {
      const colors = this.content.theme === "dark" ? "text-white" : "text-dark";
      return [
        colors,
        this.backgroundImage ? "full-right" : ""
      ];
    },
    contentUrl() {
      return this.authorized ? this.getContentURL(this.content) : false;
    },
    backgroundImage() {
      if (this.content.thumbnail && this.content.image_mode == "background") {
        let thumbnail = null;
        if (this.forceMobileThumbnail) {
          thumbnail = get(this.content, ['thumbnail_mobile', 'url'], false) || get(this.content, ['image_mobile', 'url'], false);
        }
        return thumbnail ? `url(${thumbnail})` : this.getTileThumbnailUrl();
      }
      return false;
    },
    sideImage() {
      if (this.content.thumbnail && (this.content.image_mode == "side" || !this.content.image_mode)) {
        return this.getTileThumbnailUrl();
      }
      return false;
    },
    componentTag() {
      return this.authorized ? "a" : "div";
    },
    lockIcon() {
      return lockIcon;
    },
    collectionIcon() {
      const icon = this.content.theme === "dark" ? collectionIcon : collectionIconLight;
      return icon;
    }
  }
};
</script>

<template>
  <component
    tile-component
    :style="theme"
    :class="contentType"
    :is="componentTag"
    v-easyadmin="easyadminId"
    class="position-relative d-block"
    :href="contentUrl"
    :target="getTarget(content.url)"
  >
    <div
      v-if="!authorized"
      class="position-absolute-center locked-layer w-100 h-100 cursor-pointer"
      @click.prevent="mayRedirectOnFreeContent(true)"
      >
    </div>
    <div class="bg-cover-center position-absolute-center background" v-if="backgroundImage" :style="{'background-image': backgroundImage}">
      <div class="bg-custom-gradient position-absolute" v-if="content.icon && !content.hide_gradient"></div>
      <div class="icon-container d-inline-block position-absolute" :class="content.theme == 'dark' ? 'text-white' : 'text-dark'">
        {{childrenCount}} <span :class="collectionIconClasses" v-html="collectionIcon">
          </span>
        <!-- <img :src="collectionIcon" class="icon"/> -->
      </div>
    </div>
    <div class="d-flex flex-column-reverse flex-md-row tile__content h-100" :class="this.content.theme == 'dark' ? 'text-white' : 'text-dark'">
      <div class="tile__text-section p-3 d-flex flex-column justify-content-between h-100">
        <div>
          <div
            v-if="category"
            class="tile__category category small mb-3 d-inline-block px-3 py-1"
            :class="content.category_class ? content.category_class : content.theme == 'dark' ? 'white' : 'dark'"
          >
            <div class="d-flex align-items-center">
              <img v-if="categoryIcon && categoryIcon.url" :src="categoryIcon.url" class="category-icon mr-2"/> 
              <i v-else-if="categoryIcon" class="fas mr-2" :class="`fa-${categoryIcon}`"></i>
              {{category}}
            </div>
          </div>
          <p v-if="content.title" class="h4 font-weight-bold dotdotdot-title">{{content.title}}</p>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="cursor-pointer pb-2 link-label" :class="linkLabelClasses">
            <i class="far fa-chevron-right mr-2"></i>
            <span>{{content.url ? content.url.title : (content.button_title || ft('globals.see_content'))}}</span>
          </span>
        </div>
      </div>
      <div class="tile__image-section" v-if="sideImage">
        <div class="ar-16by9 h-100 bg-cover-center side-image position-relative" :style="{'background-image': sideImage}">
          <div class="bg-custom-gradient position-absolute" v-if="content.icon && !content.hide_gradient"></div>
          <img v-if="content.icon" :src="content.icon.url" class="position-absolute icon"/>
        </div>
      </div>
    </div>
  </component>
</template>

<style lang="scss" scoped>

  [tile-component] {
    background-color: var(--theme-background);
  }

  @include media-breakpoint-down(xs) {
    .h3 {
      font-size: 2.25rem;
    }
  }

  .item--largesquarecontent {
    @include media-breakpoint-up(lg) {
      .tile__text-section  {
        padding-right: 3rem !important;
      }
    }
  }
</style>
